import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_UOM_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_UOM_ID:   {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    UOM_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'UOM Id', columnResourceName: 'colUOMId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    UOM_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT_ORDER:  {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort Order', columnResourceName: 'colSortOrder', alignment: HorizAlignment.Left, numberFormat: "#0"}, domainOptions: {}},
    MDSET_NAME: {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colMDSet', alignment: HorizAlignment.Left }, domainOptions: { maxLength: 256 }},
    ENTERPRISE_SET_ID: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Enterprise Set Id', columnResourceName: 'colEnterpriseSetId', alignment: HorizAlignment.Left }, domainOptions: { maxLength: 50 } },
    CREATED_DTTS:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date', columnResourceName: 'colCreatedDate', alignment: HorizAlignment.Center}, domainOptions: {}},
    MODIFIED_DTTS:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified Date', columnResourceName: 'colModifiedDate', alignment: HorizAlignment.Center}, domainOptions: {}},
}

var UOMSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_UOM_ID',
                id_ui: 'UOM_ID',
                name:  'UOM_NAME'},


    searchProviderFields: vUI_UOM_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_UOM_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var UOMSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UOMSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',       searchProviderFieldId: 'UOM_ID',        renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'UOM_NAME',      renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'UOM_ID','UOM_NAME','SORT_ORDER','MDSET_NAME','ENTERPRISE_SET_ID',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UOMSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var UOMSearch: ISearch = {
    searchName: "Find UOM",
    renderOptions: { ui5ResourceId: "UOMSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UOMSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("UOMBO", "UOM", UOMSearch, "UOM Search")

export {UOMSearch}